
export default (state, root) => {
  const sort = []
  for (const key in state.sort[root]) {
    const value = state.sort[root][key]
    if (value !== 'both') sort.push(`${key},${value}`)
  }
  return sort.length === 0 ? '' : `&${sort.map(value => `sort=${value}`).join('&')}`
}
